import React from 'react'
import LinkableService from './LinkableService'

export default class ConnectedServices extends React.Component {
  render () {
    return (
      <div className='user-edit-services clearboth'>
        <h3 className='text-boulder lg-font-size'>
                    Connected services
        </h3>
        <LinkableService service='github' />
        <LinkableService service='bitbucket' />
        <LinkableService service='gitlab' />
      </div>
    )
  }
}

window.Components.ConnectedServices = React.createFactory(ConnectedServices)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/userEdit/ConnectedServices/index.js